import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-overlay" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = {
  key: 0,
  class: "spinner-container"
}
const _hoisted_6 = {
  key: 1,
  class: "form-container"
}
const _hoisted_7 = { class: "form-input" }
const _hoisted_8 = {
  for: "issueResolved",
  class: "checkbox-label"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "form-input" }
const _hoisted_11 = { class: "radio-group" }
const _hoisted_12 = { class: "radio-label" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "radio-label" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "form-input select"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 0,
  class: "error-container"
}
const _hoisted_20 = { class: "modal-footer" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]

import { onMounted, onUnmounted, ref, computed } from 'vue';
	import axios from 'axios';
	import functions from '@/use/functions';
	import Spinner from '@/components/shared/Spinner.vue';
	import { LoanBorrower } from '@/models/loans';
	import { ExclamationCircleIcon } from '@heroicons/vue/24/solid';

	
export default /*@__PURE__*/_defineComponent({
  __name: 'RedecisionErrorModal',
  props: {
    annualReviewId: {},
    annualReviewYear: {},
    loanId: {},
    onClose: { type: Function }
  },
  setup(__props: any) {

	const props = __props;

	const isLoading = ref<boolean>(false);
	const isSubmitting = ref<boolean>(false);
	const errorProcessing = ref<boolean>(false);

	const issueResolved = ref<boolean>(false);
	const redecisionOption = ref<string | null>(null);
	const selectedBorrowers = ref<number | null>(null);

	const borrowers = ref<LoanBorrower[]>([]);
	const primaryBorrower = ref<LoanBorrower>();
	const coBorrower = ref<LoanBorrower | null>(null);

	const isBorrowerSelectionRequired = computed(() => redecisionOption.value === 'repullAndRedecision');

	const isFormValid = computed(() => {
		const hasIssueResolved = issueResolved.value;
		const hasRedecisionOption = redecisionOption.value !== null;

		const hasSelectedBorrower =
			redecisionOption.value === 'repullAndRedecision' ? selectedBorrowers.value !== null : true;

		return hasIssueResolved && hasRedecisionOption && hasSelectedBorrower;
	});

	const isInputDisabled = computed(() => isLoading.value || isSubmitting.value);

	const borrowerOptions = computed(() => {
		if (!coBorrower.value) {
			return [{ key: 'primary', value: 0, label: primaryBorrower.value?.fullName }];
		}

		return [
			{ key: 'primary', value: 0, label: primaryBorrower.value?.fullName },
			{ key: 'co', value: 1, label: coBorrower.value?.fullName },
			{ key: 'both', value: 2, label: 'Both' }
		];
	});

	function handleClose() {
		if (isSubmitting.value) {
			return;
		}

		props.onClose();
	}

	async function submitRedecisionAsync() {
		isSubmitting.value = true;
		errorProcessing.value = false;

		try {
			const queryParams = {
				loanId: props.loanId
			};

			let request: { borrowerId: number; firstName: string; lastName: string }[];

			if (redecisionOption.value === 'repullAndRedecision') {
				const selectedBorrowersList = borrowers.value.filter((b) => {
					switch (selectedBorrowers.value) {
						case 0:
							return b.borrowerTypeId === 1;
						case 1:
							return b.borrowerTypeId === 2;
						case 2:
							return true;
						default:
							return false;
					}
				});

				request = selectedBorrowersList.map((b) => ({
					borrowerId: b.id,
					firstName: b.firstName,
					lastName: b.lastName
				}));
			} else {
				request = [];
			}

			console.log(request);

			await axios.post(`/api/annualreview/${props.annualReviewId}/redecision`, request, { params: queryParams });

			functions.openModal({
				title: 'Success!',
				description: 'Re-decision successfully queued for annual review.'
			});

			props.onClose();
		} catch {
			errorProcessing.value = true;
		} finally {
			isSubmitting.value = false;
		}
	}

	async function fetchRepullDetailsAsync() {
		isLoading.value = true;

		try {
			const response = await axios.get<LoanBorrower[]>(`/api/loanservice/loans/${props.loanId}/borrowers`);

			borrowers.value = response.data.map(
				(b) => new LoanBorrower(b.id, b.borrowerTypeId, b.firstName, b.lastName)
			);

			primaryBorrower.value = borrowers.value.find((b) => b.borrowerTypeId === 1);
			coBorrower.value = borrowers.value.find((b) => b.borrowerTypeId === 2) || null;
		} catch {
			functions.openModal({
				title: 'Oops!',
				description: `There was an issue getting the re-decision details. Please try again later.`
			});
		} finally {
			isLoading.value = false;
		}
	}

	onMounted(async () => {
		document.body.style.overflow = 'hidden';

		await fetchRepullDetailsAsync();
	});

	onUnmounted(() => {
		document.body.style.overflow = '';
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("h3", null, "Decision Error Processing", -1)),
        _createElementVNode("span", {
          class: _normalizeClass(["close", { disabled: isSubmitting.value }]),
          onClick: handleClose
        }, "×", 2)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[15] || (_cache[15] = _createElementVNode("p", null, "Before performing a re-decision, please confirm the following:", -1)),
        _createElementVNode("form", null, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(Spinner)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "issueResolved",
                      name: "issueResolved",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((issueResolved).value = $event)),
                      disabled: isInputDisabled.value,
                      required: ""
                    }, null, 8, _hoisted_9), [
                      [_vModelCheckbox, issueResolved.value]
                    ]),
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "custom-checkbox" }, null, -1)),
                    _cache[6] || (_cache[6] = _createElementVNode("span", null, [
                      _createTextVNode(" The issue causing the decision error has been identified and resolved. "),
                      _createElementVNode("span", { class: "required" }, "*")
                    ], -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", null, [
                    _createTextVNode(" Do you want to re-decision only (use existing AR credit reports) or re-pull credit & re-decision? "),
                    _createElementVNode("span", { class: "required" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        name: "redecisionOption",
                        value: "redecisionOnly",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((redecisionOption).value = $event)),
                        disabled: isInputDisabled.value,
                        required: ""
                      }, null, 8, _hoisted_13), [
                        [_vModelRadio, redecisionOption.value]
                      ]),
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "custom-radio" }, null, -1)),
                      _cache[8] || (_cache[8] = _createTextVNode(" Re-decision only ", -1))
                    ]),
                    _createElementVNode("label", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        name: "redecisionOption",
                        value: "repullAndRedecision",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((redecisionOption).value = $event)),
                        disabled: isInputDisabled.value,
                        required: ""
                      }, null, 8, _hoisted_15), [
                        [_vModelRadio, redecisionOption.value]
                      ]),
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "custom-radio" }, null, -1)),
                      _cache[10] || (_cache[10] = _createTextVNode(" Re-pull credit & Re-decision ", -1))
                    ])
                  ])
                ]),
                (isBorrowerSelectionRequired.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "required" }, [
                        _createTextVNode(" For which borrower(s) do you want to perform the soft credit re-pull? "),
                        _createElementVNode("span", { class: "required" }, "*")
                      ], -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedBorrowers).value = $event)),
                        disabled: !isBorrowerSelectionRequired.value || isInputDisabled.value,
                        required: ""
                      }, [
                        _cache[12] || (_cache[12] = _createElementVNode("option", {
                          key: "none",
                          value: "",
                          disabled: "",
                          selected: ""
                        }, "Select an option", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(borrowerOptions.value, (option) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: option.key,
                            value: option.value
                          }, _toDisplayString(option.label), 9, _hoisted_18))
                        }), 128))
                      ], 8, _hoisted_17), [
                        [_vModelSelect, selectedBorrowers.value]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("p", null, [
          _createTextVNode(" By clicking the "),
          _createElementVNode("i", null, "“Submit”"),
          _createTextVNode(" button, I am kicking off the process to re-decision this line of credit for annual review. ")
        ], -1)),
        (errorProcessing.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(_unref(ExclamationCircleIcon), { class: "error-icon" }),
              _cache[14] || (_cache[14] = _createElementVNode("p", { class: "error" }, "The re-decision failed to process. Please close this and try again later.", -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        (isSubmitting.value)
          ? (_openBlock(), _createBlock(Spinner, {
              key: 0,
              class: "small"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "secondary",
          onClick: handleClose,
          disabled: isSubmitting.value
        }, "Cancel", 8, _hoisted_21),
        _createElementVNode("button", {
          onClick: submitRedecisionAsync,
          disabled: !isFormValid.value || isSubmitting.value
        }, "Submit", 8, _hoisted_22)
      ])
    ])
  ]))
}
}

})